import React from 'react';
import './NavIcon/navIcon.scss';

type PropType = {
  icon: string;
};

const defaultProp: Partial<PropType> = {
  icon: '',
};

function NavIcon(props: PropType) {
  let iconContainer = '';
  switch (props.icon) {
    case 'options':
      iconContainer = 'navIcon-options';
      break;
    case 'default':
      iconContainer = 'navIcon-default';
      break;
    case 'esg':
      iconContainer = 'navIcon-esg';
      break;
    case 'drop':
      iconContainer = 'navIcon-drop';
      break;
    case 'plus':
      iconContainer = 'navIcon-plus';
      break;
    case 'minus':
      iconContainer = 'navIcon-minus';
      break;
    case 'position':
      iconContainer = 'navIcon-position';
      break;
    case 'search':
      iconContainer = 'navIcon-search';
      break;
    case 'rollDown':
      iconContainer = 'navIcon-rollDown';
      break;
    case 'rollUp':
      iconContainer = 'navIcon-rollUp';
      break;
  }
  return <strong className={'icon ' + iconContainer} />;
}

NavIcon.defaultProps = defaultProp;
export default NavIcon;
